<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Upload Tax Document
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <form
        class="dropbox-form"
        enctype="multipart/form-data"
      >
        <div class="dropbox-container">
          <input
            ref="profile"
            type="file"
            aria-label="upload"
            class="db-input"
            @change="onFileSelect"
          >
          <img
            class="spreadsheet"
            src="@shared/assets/img/technician/spreadsheet.png"
            alt="Spreadsheet"
          >
          <div class="sac__font-16">
            Upload tax document in PDF format.
          </div>
        </div>
      </form>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-cancel-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UploadTaxDocument',
  props: {
    changes: Function,
    toggleActionModal: Function,
  },
  data() {
    return {
      fileName: '',
    };
  },
  computed: {
    ...mapState({
      allTaxExemptions: (state) => state.partnerAgreement.allTaxExemptions,
      selectedCorpId: (state) => state.partnerAgreement.selectedCorpId,
    }),
  },
  methods: {
    onFileSelect(e) {
      const [file] = e.target.files;
      this.fileName = file?.name;
      const newAllTaxExemptions = { ...this.allTaxExemptions };
      const taxExemption = newAllTaxExemptions[this.selectedCorpId];
      taxExemption.exempt = true;
      taxExemption.tempFile = file;
      taxExemption.tempFileName = file.name;
      newAllTaxExemptions[this.selectedCorpId] = taxExemption;
      this.$store.dispatch('changePartnerAgreementValues', [{
        field: 'allTaxExemptions',
        value: newAllTaxExemptions,
      }, {
        field: 'showActionModal',
        value: false,
      }]);
    },
  },
};
</script>

<style lang="scss" scoped>
.dropbox-form {
  align-items: center;
  flex: 1;
  width: 100%;
  .dropbox-sub-container {
    margin-top: 16px;
    display: flex;
    border-radius: 5px;
    text-align: left;
    font-weight: 500;

    .upload-multiple-user {
      letter-spacing: 0;
      line-height: 24px;
      min-height: 48px;
      position: relative;
      // width: 373px;

      .browse-item {
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .input-sub-container {
      display: none;
    }
  }

  .dropbox-container {
    border: 3px dashed $BLACK;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    gap: 16px;
    padding: 48px;
    &:hover {
      opacity: 0.5;
    }

    .spreadsheet {
      height: 96px;
      width: 77px;
    }

    .db-input {
      opacity: 0;
      position: absolute;
      height: 80%;
      width: 75%;
      cursor: pointer;
    }

    .db-header {
      display: flex;
      flex-direction: column;
      font-size: 1.25rem;
      font-weight: 500;
      text-align: center;
    }
  }
}
</style>
